
import { Typography } from '@mui/material';
import React from 'react';
import { PrimaryColor } from '../../helper/constants/colors';
import { ConsolasProps } from './helper';
const Consolas = ({ as, children, align, color= PrimaryColor.light, variant}: ConsolasProps): JSX.Element =>
(
    <Typography align={align} fontFamily="consolas" fontSize={as} color={color} variant={variant}>
        {children}
    </Typography>
)

export default Consolas;
